export default __webpack_public_path__ + "static/media/processes-enablers.c2b78045.svg";